// Success handler
function handleSuccessResponse(response) {
  return {
    ...response.data,
    status: response.status,
  };
}

// Error handler
function handleErrorResponse(error) {
  const status = error.response?.status;
  const errorData = error.response?.data?.error;

  const res = {
    ...errorData,
    status,
  };

  return Promise.reject(res);
}

export { handleSuccessResponse, handleErrorResponse };
